import { FORM_FIELDS, FORM_FIELDS_NAMES } from './new-application-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { ISelectorData } from '../../components/application/NewApplication';
import { ILists } from '../../interfaces/merchant';
import { TFunction } from 'react-i18next';

interface IAccountInformationInputsProps {
  partnerList?: ISelectorData[];
  integrationPartnersListSelector?: ISelectorData[];
  salesAgencyListSelector?: ISelectorData[];
  accountListSelector?: ISelectorData[];
  accountManagerList?: ISelectorData[];
  lists: ILists;
  t: TFunction;
  data: any;
  crmId?: string;
}

export const SUPER_ADMIN_ACCOUNT_INFO_INPUTS = ({
  t, partnerList, integrationPartnersListSelector, salesAgencyListSelector,
  accountListSelector, data, lists, accountManagerList, crmId
}: IAccountInformationInputsProps): IFormInputProps[] => [
  {
    key: FORM_FIELDS.ACCOUNT_ID,
    fieldName: FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    data: accountListSelector,
    disabled: data?.accountId,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.PARTNER_ID,
    fieldName: FORM_FIELDS.PARTNER_ID,
    placeholder: t(FORM_FIELDS_NAMES.PARTNER_ID),
    label: t(FORM_FIELDS_NAMES.PARTNER_ID),
    inputType: InputType.Select,
    required: true,
    data: partnerList,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    data: integrationPartnersListSelector,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.SALES_AGENCY_ID,
    fieldName: FORM_FIELDS.SALES_AGENCY_ID,
    placeholder: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    label: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    inputType: InputType.Select,
    data: salesAgencyListSelector,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.INTEGRATION_TIER,
    fieldName: FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    searchable: false,
    data: lists?.integrationTiers,
    required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.ACCOUNT_MANAGER,
    fieldName: FORM_FIELDS.ACCOUNT_MANAGER,
    placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    label: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    inputType: InputType.Select,
    data: accountManagerList,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.CRM_ID,
    fieldName: FORM_FIELDS.CRM_ID,
    placeholder: t(FORM_FIELDS_NAMES.CRM_ID),
    label: t(FORM_FIELDS_NAMES.CRM_ID),
    inputType: InputType.Text,
    // data: crmId,
    required: false,
    autoComplete: 'off',
  },
  {
    key: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    fieldName: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    placeholder: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    label: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    inputType: InputType.Text,
    required: false,
    autoComplete: 'off',
  },
];
export const PARTNER_ADMIN_ACCOUNT_INFO_INPUTS = ({
  t, integrationPartnersListSelector,
  accountListSelector, data, lists
}: IAccountInformationInputsProps): IFormInputProps[] => [
  {
    key: FORM_FIELDS.ACCOUNT_ID,
    fieldName: FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    data: accountListSelector,
    disabled: data?.accountId,
    autoComplete: 'off'
  },

  {
    key: FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    data: integrationPartnersListSelector,
    // required: true,
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.SALES_AGENCY_ID,
  //   fieldName: FORM_FIELDS.SALES_AGENCY_ID,
  //   placeholder: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
  //   label: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
  //   inputType: InputType.Select,
  //   data: salesAgencyListSelector,
  // },
  {
    key: FORM_FIELDS.INTEGRATION_TIER,
    fieldName: FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    searchable: false,
    data: lists?.integrationTiers,
    required: true,
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.ACCOUNT_MANAGER,
  //   fieldName: FORM_FIELDS.ACCOUNT_MANAGER,
  //   placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
  //   label: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
  //   inputType: InputType.Select,
  //   data: accountManagerList,
  //   required: true,
  // },
  {
    key: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    fieldName: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    placeholder: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    label: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    inputType: InputType.Text,
    required: false,
    autoComplete: 'off',
  },
];
export const INTEGRATION_PARTNER_ADMIN_ACCOUNT_INFO_INPUTS = ({
  t, accountListSelector, data, lists, accountManagerList, salesAgencyListSelector
}: IAccountInformationInputsProps): IFormInputProps[] => [
  {
    key: FORM_FIELDS.ACCOUNT_ID,
    fieldName: FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: accountListSelector,
    disabled: data?.accountId,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.SALES_AGENCY_ID,
    fieldName: FORM_FIELDS.SALES_AGENCY_ID,
    placeholder: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    label: t(FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    inputType: InputType.Select,
    data: salesAgencyListSelector,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.INTEGRATION_TIER,
    fieldName: FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    searchable: false,
    data: lists?.integrationTiers,
    required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.ACCOUNT_MANAGER,
    fieldName: FORM_FIELDS.ACCOUNT_MANAGER,
    placeholder: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    label: t(FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    inputType: InputType.Select,
    data: accountManagerList,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    fieldName: FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    placeholder: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    label: t(FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    inputType: InputType.Text,
    required: false,
    autoComplete: 'off',
  },
];
